export const SetUser = (data:any) => {
    window.localStorage.setItem("User_Web", btoa(JSON.stringify(data)));
  };
  export const GetUser = () => {
    console.log();
    return (
      window.localStorage.getItem("User_Web") != null &&
      JSON.parse(atob(window?.localStorage.getItem("User_Web") || '{}'))
    );
  };
  export const RemoveUser = () => {
    window.localStorage.removeItem("User_Web");
  };
  